import { SHOW_MODAL } from '../actions/show-modal';
import { HIDE_MODAL } from '../actions/hide-modal';

const initalState = {
  type: null,
  props: null,
};

export default (state = initalState, { type, payload, meta } = {}) => {
  switch (type) {
    case SHOW_MODAL:
      return {
        ...state,
        ...payload,
        ...meta,
      };
    case HIDE_MODAL:
      // TODO: fix
      // case LOCATION_CHANGE:
      return initalState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/modal.js